import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Modal section
 */
const Modal = (props) => {
  const {
    className,
    children,
    active,
    title,
    size,
    onClose,
    showCloseBtn,
    width,
    ...otherProps
  } = props;
  const classNames = classnames(
    'modal',
    className,
    {
      active,
      'modal-sm': size === 'small',
      'modal-lg': size === 'large',
    },
  );
  return (
    <div className={classNames} {...otherProps}>
      <button
        type="button"
        data-id="close-modal"
        className="modal-overlay"
        aria-label="Close"
        onClick={onClose}
      />
      <div className="modal-container" style={width ? { width: `${width}px` } : {}}>
        {
          (title || showCloseBtn) && (
            <div className="modal-header">
              {
                showCloseBtn && (
                  <button
                    type="button"
                    id="close"
                    data-id="close-modal"
                    className="btn btn-clear float-right"
                    aria-label="Close"
                    onClick={onClose}
                  />
                )
              }
              {!!title && <h4 className="modal-title h4">{title}</h4>}
            </div>
          )
        }
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Modal title */
  title: PropTypes.string,
  // Modal window custom width
  width: PropTypes.number,
  // Is modal window shown or not
  active: PropTypes.bool,
  // Is close icon shown or not
  showCloseBtn: PropTypes.bool,
  children: PropTypes.any.isRequired,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['default', 'small', 'large']),
};
Modal.defaultProps = {
  title: '',
  className: '',
  size: 'default',
  width: 0,
  active: false,
  showCloseBtn: false,
  onClose: () => {},
};

/**
 * Modal content
 */
Modal.Body = ({ children }) => (
  <div className="modal-body">
    {children}
  </div>
);
Modal.Body.propTypes = {
  children: PropTypes.any.isRequired,
};

/**
 * Modal actions
 */
Modal.Footer = ({ children }) => (
  <div className="modal-footer">
    {children}
  </div>
);
Modal.Footer.propTypes = {
  children: PropTypes.any.isRequired,
};

export { Modal };
